import { render, staticRenderFns } from "./FirewallRules.vue?vue&type=template&id=82ffe574&scoped=true"
import script from "./FirewallRules.vue?vue&type=script&lang=js"
export * from "./FirewallRules.vue?vue&type=script&lang=js"
import style0 from "./FirewallRules.vue?vue&type=style&index=0&id=82ffe574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ffe574",
  null
  
)

export default component.exports